import React, {  useContext, useEffect, useRef } from 'react'
import { CGE } from "../../../../common/components/CGE";
import BusquedaPrincipal from "../../../busqueda-cliente/components/BusquedaPrincipal";
import { useModal } from "@clayui/modal";
import AlertModal from '../../../../common/components/AlertModal';
import { decode_utf8 } from "../../../../common/utils/utilsFunc";
import { TOKEN_CAPTCHA_COOKIE_KEY,TOKEN_CAPTCHA_COOKIE_KEY_AUX } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';
import { PaymentOnlineContext } from '../../context/PaymentOnlineContextProvider';

function GetNumClient({ props }) {
    const [visibleModal, setVisibleModal] = React.useState(false);
    const [visibleModal2, setVisibleModal2] = React.useState(false);
    const [isClientIdCaptchaChecked, setIsClientIdCaptchaChecked] = React.useState(false);

    const [_, __, shouldClearCaptchaData] = useContext(PaymentOnlineContext)
    
    const inputRef = useRef()
    const captcha = useRef(null)

    const { observer, onClose } = useModal({
        onClose: () => {
            setVisibleModal(false);
            setVisibleModal2(false);
        }
    });
    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);
    const { updateCookieStateAux } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY_AUX);

    let propsLabelInfoContent = {
        "content": props.state?.webContentTextInfo,
        "observer": observer,
        "onClose": onClose,
        "setVisibleModal": setVisibleModal2,
        "status": "info",
        "titleModal": "Información",
        "visibleModal": visibleModal2,
        "titleHint": "Ayuda Nro de Cliente",
    }

    function handleCaptcha(captchaData) {
        updateCookieState(captchaData);
        updateCookieStateAux(captchaData);
        if (captchaData) {
            setIsClientIdCaptchaChecked(true);
        } else {
            setIsClientIdCaptchaChecked(false);
        }
    }

    useEffect(() => {
        if (!shouldClearCaptchaData.current) return

        inputRef.current.value = ''

        captcha.current.reset()
        updateCookieState(null);
        updateCookieStateAux(null)
        setIsClientIdCaptchaChecked(false)
        shouldClearCaptchaData.current = false
    }, [shouldClearCaptchaData.current, updateCookieState, updateCookieStateAux])

    return (
        <div className="" >
            <CGE.Panel>
                <div>
                    {props.can_enter_the_customer_number === "true" ?
                        <>
                            <CGE.FormsField
                                handleChange={(e) => {
                                    props.setNumCli(String(e.target.value).trim());
                                }}
                                idFormElement="numClaim"
                                typeFormElement="text"
                                mandatoryElement={true}
                                typeElement="input"
                                hasError={false}
                                placeholder="N° de Cliente"
                                propsLabelInfoContent={propsLabelInfoContent}
                                labelName="Número de Cliente:"
                                value={props.numCli}
                                atcRef={inputRef}
                            />
                            <CGE.FieldRecaptcha
                                onChange={handleCaptcha}
                                sitekey={props.api_key_recaptcha}
                                captchaRef={captcha}
                            />
                            <div className="d-flex justify-content-center" >
                                <CGE.Button
                                    label="Ingresar"
                                    onClick={() => {
                                        if (!isClientIdCaptchaChecked) {
                                            return props.setGlobalAlert("Falta validar que no eres un Robot.", "warning");
                                        }

                                        props.nextStep()
                                    }}
                                    className=""
                                    size="sm"
                                />
                            </div>
                        </>
                        :
                        <>
                            <CGE.Text size="4" text={decode_utf8(props.msg_cant_enter_the_customer_numer)} style={{ color: 'red' }} />
                        </>
                    }

                    <div className="d-flex justify-content-center" >
                        <CGE.Button
                            label="¿Cuál es mi número de cliente?"
                            onClick={() => { window.location.href = "busqueda-cliente?pago-en-linea=1" }}
                            className="mb-2"
                            type="ghost"
                        />
                    </div>
                    {visibleModal && (
                        <AlertModal
                            titleModal="Información"
                            observer={observer}
                            onClose={onClose}
                            status="info"
                        >
                            <BusquedaPrincipal setGlobalAlert={props.setGlobalAlert} />
                        </AlertModal>
                    )}
                </div>
            </CGE.Panel>
        </div>
    )
}

export default GetNumClient;